import { REPORT_ENUM } from '@/assets/scripts/reportEnum';

export default {
  namespaced: true,
  state: {
    stateTable: REPORT_ENUM.REQUEST_AWAITING,
  },
  getters: {
    getStateTable: (state) => state.stateTable,
  },
  mutations: {
    setStateTable: (state, payload) => {
      state.stateTable = payload;
    },
  },
};
